/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** vertx (ignored)
 ** module id = 35
 ** module chunks = 3
 **/